module.exports = __webpack_public_path__ + "img/jjtg_img@2x.03118db4.png";